import { forwardRef, useState } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  Investors,
  setBalanceDialog,
} from "../../../../app/slices/investorsSlice";
import {
  HiOutlineWallet,
  HiOutlineArrowDownTray,
  HiOutlineArrowUpTray,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

const InitialSupplierBalanceForm = () => {
  const _InitialSupplierBalance = useSelector(
    (state) => state.investors.balance
  );
  const _SearchBody = useSelector((state) => state.investors.searchBody);

  const isDeposit = _InitialSupplierBalance.type === "deposit";

  const { control, handleSubmit } = useForm({
    defaultValues: _InitialSupplierBalance.form,
  });

  const [saving, setSaving] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      if (isDeposit) {
        await dispatch(
          Investors.deposit(
            _InitialSupplierBalance.investor_id,
            {
              amount: data.amount,
            },
            _SearchBody
          )
        );
      } else {
        await dispatch(
          Investors.withdraw(
            _InitialSupplierBalance.investor_id,
            {
              amount: data.amount,
            },
            _SearchBody
          )
        );
      }
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    dispatch(
      setBalanceDialog({
        id: null,
        type: null,
      })
    );
  };

  return (
    <FormDialog
      open={_InitialSupplierBalance.dialog}
      onClose={handleClose}
      icon={isDeposit ? <HiOutlineArrowDownTray /> : <HiOutlineArrowUpTray />}
      title={isDeposit ? "اضافة رصيد" : "سحب رصيد"}
      subtitle={
        isDeposit
          ? "حدد المبلغ الذي سيضاف الى رصيد الممول"
          : "حدد المبلغ الذي سيسحب من رصيد الممول"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={saving}
    >
      <SectionCard icon={<HiOutlineWallet />} title="المبلغ">
        <Grid item xs={12}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default InitialSupplierBalanceForm;
